import { useWishlistLists } from '@components/Universals/WishlistModifier/useWishlistLists';
import { GTM_WISHLIST_PAGE_TYPE } from '@containers/WishList/constants';
import { dispatchTrackingEvent } from '@context/tracking/utils';

export const trackWishlistPageViewEvent = () => {
  const defaultListId = useWishlistLists.DEFAULT_LIST_ID;

  const pathname = window.location.pathname;
  const lastPart = pathname.split('/').pop();
  const path =
    !lastPart || lastPart === defaultListId
      ? pathname.replace(/\/wishlist\/.*$/, `/wishlist/${defaultListId}`)
      : pathname.replace(/\/wishlist\/.*/, '/wishlist/shared');

  dispatchTrackingEvent({
    event: 'page_view',
    page: {
      title: 'Wishlist',
      path,
      unified_name: 'wishlist',
      type: GTM_WISHLIST_PAGE_TYPE,
      subpage: undefined,
      referrer: document.referrer,
    },
    _clear: true,
  });
};
